import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { EDSFiltersRequestBody } from '@/features/eds/types/api/requests/EDSFiltersRequestBody';
import { PartiesSliceState } from '@/features/parties/store/types';
import { PartiesEntityResponse } from '@/features/parties/types/responses/partiesEntityData';

const initialState: PartiesSliceState = {
  partiesList: [],
  savedFiltersForSending: null,
  statuses: {
    isPartiesLoading: false,
  },
};

const partiesSlice = createSlice({
  name: 'parties',
  initialState,
  reducers: {
    resetPartiessSlice: () => initialState,
    getPartiesList: (_, _action: PayloadAction<number>) => {},
    getPartiesListSuccess: (state, { payload }: PayloadAction<PartiesEntityResponse[]>) => {
      state.partiesList = payload;
    },
    setPartiesListLoading: (state, { payload }: PayloadAction<boolean>) => {
      state.statuses.isPartiesLoading = payload;
    },
    updatePartiesSavedFiltersForSending: (state, { payload }: PayloadAction<EDSFiltersRequestBody>) => {
      state.savedFiltersForSending = payload;
    },
  },
});

export const {
  getPartiesList,
  updatePartiesSavedFiltersForSending,
  getPartiesListSuccess,
  setPartiesListLoading,
  resetPartiessSlice,
} = partiesSlice.actions;

export const partiesReducer = partiesSlice.reducer;
export const partiesReducerPath = partiesSlice.reducerPath;
